import { AllCardsType } from '../../../data/all-cards'
import { NombreTarotista } from '../../../data/personality'
import { DataTypePregunta } from '../../../interfaces/utils'
import { formatCardLabel } from '../../../utils/card-label'

const cardLabel = (card: AllCardsType) => formatCardLabel(card)

export const interpret = (
    cards: AllCardsType[],
    data: DataTypePregunta,
    user: string,
    personality: NombreTarotista,
    type: string
) => {
    const consult = `Quiero que interpretes una **Tirada de Conexión con tu Yo Futuro** con 10 cartas, ayudando al consultante ${
        data.consultante
    } a conectar con la versión de sí mismo que puede llegar a ser en los próximos 1 a 3 años, ${
        data.consulta.length > 0
            ? 'ten en cuenta en la tirada la siguiente consulta que realiza el consultante: ' +
              data.consulta +
              ','
            : ''
    } según estas cartas: **Energía actual del consultante:** ${cardLabel(cards[0])}, **Lo que más está pidiendo atención ahora:** ${cardLabel(
        cards[1]
    )}, **Energía y presencia del Yo Futuro (quién se convierte esta persona dentro de 1 a 3 años; enfócate en su identidad, energía, presencia y cualidades principales):** ${cardLabel(
        cards[2]
    )}, **Cómo se siente emocionalmente esa versión futura:** ${cardLabel(cards[3])}, **Qué está creando o viviendo esa versión futura:** ${cardLabel(
        cards[4]
    )}, **Qué necesita soltar para llegar ahí:** ${cardLabel(cards[5])}, **Qué necesita cultivar o activar:** ${cardLabel(
        cards[6]
    )}, **Apoyo invisible o guías que ya tiene disponible:** ${cardLabel(cards[7])}, **El paso más poderoso y realista que puede dar ahora:** ${cardLabel(
        cards[8]
    )} y **Mensaje final de su Yo Futuro + visión del camino si sigue esta línea:** ${cardLabel(
        cards[9]
    )}. Explica detalladamente cada carta y su significado en la posición donde ha salido. Conecta el presente con el yo futuro: muestra cómo la energía actual, lo que pide atención y lo que debe soltar o cultivar se relacionan con la identidad y el camino que revela el yo futuro. Detecta patrones, bloqueos y oportunidades en la lectura. Proporciona consejos prácticos, realistas y motivadores para acercarse a esa versión futura. Mantén un tono profesional, empático, esperanzador y comprensible. Dirígete directamente al consultante, no utilices la tercera persona refiriéndote al consultante, aún cuando las consultas se encuentren en tercera persona, adapta la respuesta para que quede en segunda persona. Incluye además en 2 párrafos después de la lectura, una respuesta directa para el consultante y un consejo final (extra-tarot).`

    return {
        consult,
        user,
        personality,
        clientName: data.consultante.name,
        clientPhone: data.consultante.phone || '',
        clientAnswer: data.consulta,
        cards,
        type,
    }
}
